// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export default noop;
